import React, { useState } from 'react';
import Globals from '../Globals';
import { db } from "../firebase";
import { doc, updateDoc, arrayUnion} from "firebase/firestore";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Toast from 'react-bootstrap/Toast';
import ToggleCheckboxImage from '../Components/ToggleCheckboxImage';

const AddPlayerToRoster = ({setCurrentTask, currentTask, setPlayers, players, teamName}) => {
    const [newPlayerName, setNewPlayerName] = useState('');
    const [playerEmail, setPlayerEmail] = useState('');
    const [isSub, setIsSub] = useState(false);
    const [isStaff, setIsStaff] = useState(false);
    const [playerAlreadyExists, setPlayerAlreadyExists] = useState(false);
    const addPlayer = async (e) => {
        e.preventDefault();

        if(players.find(v => v.name === newPlayerName)){
            setPlayerAlreadyExists(true);
            return;
        }
        
        setCurrentTask(currentTask.none);

        console.log(newPlayerName, isSub, playerEmail, isStaff);

        const assignNewPlayerInfo = new Globals.assignNewPlayerInfo(newPlayerName, isSub);
        assignNewPlayerInfo.email = playerEmail;
        assignNewPlayerInfo.isStaff = isStaff;
        
        try{
            console.log(players);
            if(newPlayerName && playerEmail){
                setPlayers([...players, assignNewPlayerInfo]);
                const docRef = doc(db, "teams", teamName);
                const updateData = {
                    players: arrayUnion({...assignNewPlayerInfo}),
                    authorizedEmails: arrayUnion(playerEmail)
                };
                if (isStaff) {
                    updateData.staffEmails = arrayUnion(playerEmail);
                }
                await updateDoc(docRef, updateData);
                // Reset form
                setNewPlayerName('');
                setPlayerEmail('');
                setIsSub(false);
                setIsStaff(false);
            }
        }
        catch(e){
            console.error(e);
        }
    }

    return (
        <Modal show={currentTask===Globals.taskNumbers.add} onHide={() => {setCurrentTask(Globals.taskNumbers.none)} }>
            <Form onSubmit={addPlayer}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Player</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="newPlayerName">Player Name</Form.Label>
                        <Form.Control
                            id='newPlayerName'
                            placeholder="Name"
                            aria-label="New player name"
                            required
                            onChange={(e) => {setNewPlayerName(e.currentTarget.value)}}
                            value={newPlayerName}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="playerEmail">Email Address</Form.Label>
                        <Form.Control
                            id='playerEmail'
                            type="email"
                            placeholder="player@example.com"
                            aria-label="Player email address"
                            required
                            onChange={(e) => {setPlayerEmail(e.currentTarget.value)}}
                            value={playerEmail}
                        />
                    </Form.Group>

                    <InputGroup className="mb-3">
                        <InputGroup.Text>Is Sub</InputGroup.Text>
                        <div className="input-group-append" style={{flex: 1, display: 'flex', alignItems: 'center', paddingLeft: '10px'}}>
                            <ToggleButton
                                id="isSub"
                                type="checkbox"
                                variant="secondary"
                                checked={isSub}
                                value={0}
                                onChange={ () => setIsSub(!isSub) }
                                >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="svgToSwap bi bi-x-lg" viewBox="0 0 16 16">
                                    <ToggleCheckboxImage booleanValue={isSub}/>
                                </svg>      
                            </ToggleButton>
                        </div>
                    </InputGroup>

                    <InputGroup className="mb-3">
                        <InputGroup.Text>Is Staff</InputGroup.Text>
                        <div className="input-group-append" style={{flex: 1, display: 'flex', alignItems: 'center', paddingLeft: '10px'}}>
                            <ToggleButton
                                id="isStaff"
                                type="checkbox"
                                variant="secondary"
                                checked={isStaff}
                                value={0}
                                onChange={ () => setIsStaff(!isStaff) }
                                >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="svgToSwap bi bi-x-lg" viewBox="0 0 16 16">
                                    <ToggleCheckboxImage booleanValue={isStaff}/>
                                </svg>      
                            </ToggleButton>
                        </div>
                    </InputGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" type='submit'>
                        Save
                    </Button>
                    <Button variant="secondary" onClick={() => {
                        setCurrentTask(Globals.taskNumbers.none);
                        setNewPlayerName('');
                        setPlayerEmail('');
                        setIsSub(false);
                        setIsStaff(false);
                    }}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Form>
            <div className="toast-container position-fixed bottom-0 end-0 p-3">
                <Toast show={playerAlreadyExists} onClose={() => setPlayerAlreadyExists(!playerAlreadyExists)} delay={3000} autohide bg='danger'>
                    <Toast.Body>A player with that name already exists. Please use another name.</Toast.Body>
                </Toast>
            </div>
        </Modal>
    )
}

export default AddPlayerToRoster;
